export default __webpack_public_path__ + "static/media/paymentLink 1.07681cfd.svg";